'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";

import Button from "react-bootstrap/Button";

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";

import registerButtonStore from "./RegisterButtonStore";

class RegisterButton extends Component {
    constructor(props) {
        super(props);
        this.props = props;

        this.store = registerButtonStore;
    }

    componentDidMount() {
        this.store.mount(this.props.slnData, this.props.termId);
    }

    componentDidUpdate(prevProps) {
        if ( this.props.termId !== prevProps.termId ) {
            this.store.mount(this.props.slnData, this.props.termId);
        }
    }

    render() {
        switch (this.store.state) {
            case States.pending:
            case States.initial:
                return (
                    <Button variant={this.props.variant}>{this.props.children}</Button>
                );
            case States.error:
                return null;
            case States.done:
                return (
                    <Button
                        href={this.store.buildRegisterUrl()}
                        target="_blank"
                        disabled={this.store.isDisabled()}
                        onClick={this.props.onClick}
                        variant={this.props.variant}
                        className="px-4">
                        {this.props.children}
                    </Button>
                );
        }
    }
}

RegisterButton.propTypes = {
    slnData: PropTypes.object.isRequired,
    termId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    variant: PropTypes.string
}

RegisterButton.defaultProps = {
    slnData: {},
    termId: '',
    onClick: () => {}, // No-op default function
    variant: 'primary'
}

export default observer(RegisterButton);